import http from '@/plugins/axios_plugin';

class ServiceTamanhos {
    listar () {
        return http.get('/api/tamanhos')
    }

    listarTamanhosProduto(produto_id) {
        return http.get(`/api/tamanhos/${produto_id}`);
    }

    salvar (tamanho) {
        return http.post('/api/tamanhos/salvar', tamanho)
    }

    atualizar (tamanho_id, tamanho) {
        return http.post('/api/tamanhos/' + tamanho_id + '/atualizar', tamanho)
    }

    excluir (tamanho_id) {
        return http.post('/api/tamanhos/' + tamanho_id + '/excluir', tamanho_id)
    }
}

export default new ServiceTamanhos();